import { FT5_MOVE_TRACKING } from '../../../constants';
import { DataContainer, submitMove } from '@otto-ec/tracking-bct';
import { getProductFeaturesForNonPdpPage } from '../../../_common/client/tracking/get-product-features-for-non-pdp-page';

export function registerMoveTracking(variationData: { variationId: string }) {
    o_global.eventQBus.on(FT5_MOVE_TRACKING, (trackingData: DataContainer) => {
        submitMove(trackingData, {
            name: 'click',
            features: getProductFeaturesForNonPdpPage(variationData),
        });
    });
}
